'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# OhioSVG
An SVG Ohio icon
 */
var OhioSVG = function OhioSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 600 600',
      'aria-label': 'Ohio',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Ohio'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'An icon in the shape of the outline of Ohio'
    ),
    _react2.default.createElement(
      'g',
      {
        fill: color
      },
      _react2.default.createElement('path', { d: 'M579.3,0.2c10.8-1.9,9.8,8.7,9.8,15c0.2,80.9,0.2,161.9,0.2,242.8c0,77.7-0.7,152.5-0.7,230.3\r c-7.7,2.9-15.2,5.9-22.9,9c-75.6,28.8-151,57.6-226.4,86.7c-12,4.7-19.5,7.7-34.5,13.8c-9.2,4-11.2,2.2-20-1\r c-12.6-5.6-23.1-9.2-36.5-14.4c-79.2-30.8-158.3-61-237.7-91.6c0-157,0-313.8,0-470.9c66.5,0.2,133,0.9,199.2,0.2\r c17.3-0.2,29.4,4.2,40,18.8c24,33.5,55.6,44.7,96.1,31c30.7-10.3,62.7-15.9,93.6-25.2C486.6,30.8,532.8,15.2,579.3,0.2z'
      })
    )
  );
};

OhioSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** a color for the icon */
  color: _propTypes2.default.string
};

OhioSVG.displayName = 'OhioSVG';

exports.default = OhioSVG;
OhioSVG.__docgenInfo = {
  'description': '# OhioSVG\r\nAn SVG Ohio icon',
  'methods': [],
  'displayName': 'OhioSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    }
  }
};